import { VariantProps, cva } from "class-variance-authority"
import { DetailedHTMLProps, HTMLAttributes, forwardRef } from "react"
import { cn } from "../../lib/utils"
import { REPORT_PAGE_BODY_HEIGHT_PX } from "./reportGeneratorUtils"

const reportPageBodyVariants = cva(
	"grid grid-flow-row w-full grid-rows-[repeat(60,minmax(0,1fr))] grid-cols-[repeat(60,minmax(0,1fr))] content-start justify-start gap-4",
	{
		variants: {
			company: {
				dipai: "",
			},
		},
		defaultVariants: {
			company: "dipai",
		},
	}
)

export interface IReportPageBodyProps
	extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
		VariantProps<typeof reportPageBodyVariants> {}

const ReportPageBody = forwardRef<HTMLDivElement, IReportPageBodyProps>((props, ref) => {
	const { className, children, company, style, ...rest } = props
	return (
		<div
			ref={ref}
			className={cn(reportPageBodyVariants({ company, className }))}
			style={{ height: `${REPORT_PAGE_BODY_HEIGHT_PX}px`, ...style }}
			{...rest}
		>
			{children}
		</div>
	)
})

export { ReportPageBody, reportPageBodyVariants }
